import {useEffect, useState} from "react";
import {Copy} from "../copy/Copy";
import {useThemeSelector} from "../../../../hooks/theme/useThemeSelector";
import {ThemeElementType} from "../../../../hooks/theme/ThemeElementType";
import {DefaultCopy} from "../copy/DefaultCopy";
import {EmergeCopy} from "../copy/EmergeCopy";
import {SquareOneCopy} from "../copy/SquareOneCopy";

interface ThemedCopy {
    copy: Copy
}

export const useThemedCopy = (): ThemedCopy => {

    const { theme } = useThemeSelector()
    const [copy, setCopy] = useState<Copy>(DefaultCopy)

    useEffect(() => {
        if (theme) {
            switch (theme.toUpperCase()) {
                case ThemeElementType.VASTBANK:
                    setCopy(DefaultCopy)
                    break
                case ThemeElementType.EMERGE:
                    setCopy(EmergeCopy)
                    break
                case ThemeElementType.SQUAREONE:
                    setCopy(SquareOneCopy)
                    break
                default:
                    setCopy(DefaultCopy)
            }
        }
    }, [theme]);

    return { copy }

}